<template>
  <section class="features bg-grey-100 py-10 tablet:py-28">
    <div class="grid-container">
      <div class="col-span-12 flex flex-col tablet:flex-row tablet:justify-between">
        <div>
          <h2 class="mb-8 text-headline-xl tablet:mb-14">
            {{ $t('new_job_landing.features.heading') }}
          </h2>

          <div class="mb-6 flex gap-x-6 overflow-x-auto tablet:mb-0 tablet:flex-col tablet:overflow-hidden">
            <a
              v-for="{ id, label } in tabs"
              :key="id"
              class="relative block shrink-0 cursor-pointer py-3 pl-4 text-xs font-semibold uppercase before:absolute before:top-0 before:left-[1px] before:h-full before:w-[1px] before:bg-grey hover:text-mint"
              :class="{
                'before:left-[0.5px] before:w-[3px] before:bg-mint': activeTab === id,
              }"
              @click="activeFeature(id)"
            >
              {{ label }}
            </a>
          </div>
        </div>

        <div class="max-w-2xl">
          <template v-for="{ id, img, description } in tabContents">
            <div v-if="activeTab === id" :key="id">
              <img :src="img" />

              <div class="text-center">
                {{ description }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import HighlightingImg from '@/assets/images/feature-highlight.png'
import SocialMediaPushImg from '@/assets/images/feature-network-push.png'
import RefreshHalftimeImg from '@/assets/images/feature-refresh-15.png'
import Refresh30Img from '@/assets/images/feature-refresh-30.png'
import TopJobImg from '@/assets/images/feature-topjob.png'
import { JOB_FEATURE } from '@/helpers/constants'

import { useNuxtApp } from '#imports'

const { $i18n } = useNuxtApp()

const activeTab = ref(JOB_FEATURE.REFRESH_HALFTIME)

const tabs = computed(() => [
  {
    id: JOB_FEATURE.SOCIAL_MEDIA_PUSH,
    label: $i18n.t('new_job_landing.features.social_media_push'),
  },
  {
    id: JOB_FEATURE.REFRESH_HALFTIME,
    label: $i18n.t('new_job_landing.features.halftime'),
  },
  {
    id: JOB_FEATURE.REFRESH_30,
    label: $i18n.t('new_job_landing.features.refresh_30'),
  },
  {
    id: JOB_FEATURE.TOP_JOB,
    label: $i18n.t('new_job_landing.features.top_job'),
  },
  {
    id: JOB_FEATURE.HIGHLIGHTING,
    label: $i18n.t('new_job_landing.features.highlighting'),
  },
])

const tabContents = computed(() => [
  {
    id: JOB_FEATURE.SOCIAL_MEDIA_PUSH,
    img: SocialMediaPushImg,
    description: $i18n.t('new_job_landing.features.description.social_media_push'),
  },
  {
    id: JOB_FEATURE.REFRESH_HALFTIME,
    img: RefreshHalftimeImg,
    description: $i18n.t('new_job_landing.features.description.halftime'),
  },
  {
    id: JOB_FEATURE.REFRESH_30,
    img: Refresh30Img,
    description: $i18n.t('new_job_landing.features.description.refresh_30'),
  },
  {
    id: JOB_FEATURE.TOP_JOB,
    img: TopJobImg,
    description: $i18n.t('new_job_landing.features.description.top_job'),
  },
  {
    id: JOB_FEATURE.HIGHLIGHTING,
    img: HighlightingImg,
    description: $i18n.t('new_job_landing.features.description.highlighting'),
  },
])

const activeFeature = (id: string) => {
  activeTab.value = id
}
</script>
